import { ColumnsType } from "antd/es/table";
import { useMemo } from "react";
import { useStatusTag } from "../../../../../../Accounts/hooks/statusTag";
import { Link } from "react-router-dom";
import ROUTES from "../../../../../../../configs/routesConfig";

export const useGetAccountsTableColumns = () => {
  const { getStatus } = useStatusTag();

  const columns: ColumnsType<any> = useMemo(
    () => [
      {
        title: "Account #",
        dataIndex: "accountNumber",
        ellipsis: true,
        width: "20%",
        render: (value: number, record: any) => (
          <div className="elipsis">
            <Link to={`${ROUTES.ACCOUNTS}/${record.id}`} target="_blank">
              <span className="ant-btn-link">{value}</span>
            </Link>
          </div>
        ),
      },
      {
        title: "Role",
        dataIndex: "role",
        ellipsis: true,
        width: "62%",
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (value: string | number) => getStatus(value),
        width: "18%",
      },
    ],
    [getStatus],
  );

  return { columns };
};
